import { Stack } from '@mui/material'
import { FieldDef } from './types'
import TextWidget from './fields/Text'
import RichTextWidget from './fields/RichText'
import NumberWidget from './fields/Number'
import NumberRangeWidget from './fields/NumberRange'
import ListWidget from './fields/List'
import EnumWidget from './fields/Enum'
import DimensionsWidget from './fields/Dimensions'
import TrajectoryWidget from './fields/Trajectory'
import Repeater from './fields/Repeater'

interface Props {
  fields: FieldDef[]
  values: Record<string, unknown>
  onChange: (next: Record<string, unknown>) => void
}

export default function FormRenderer({ fields, values, onChange }: Props) {
  const setField = (id: string, v: unknown) => {
    onChange({ ...values, [id]: v })
  }

  return (
    <Stack spacing={2.5}>
      {fields.map((field) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const v: any = values?.[field.id]
        const handler = (newVal: unknown) => setField(field.id, newVal)

        switch (field.type) {
          case 'text':
            return <TextWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'richText':
            return <RichTextWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'number':
            return <NumberWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'numberRange':
            return <NumberRangeWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'list':
            return <ListWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'enum':
            return <EnumWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'dimensions':
            return <DimensionsWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'trajectory':
            return <TrajectoryWidget key={field.id} field={field} value={v} onChange={handler} />
          case 'repeater':
            return <Repeater key={field.id} field={field} value={v} onChange={handler} />
          default:
            return null
        }
      })}
    </Stack>
  )
}
